import React from "react";
import Menu from "@material-ui/core/Menu";
import * as Icon from "react-feather";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";

const ProjectListActionMenu = ({ list, handleDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <button
        aria-controls={"listActions" + list.List_ID}
        aria-haspopup="true"
        className="btn btn-transparent-dark btn-sm"
        onClick={handleClick}
      >
        <Icon.MoreVertical size={18} />
      </button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <ConfirmDeleteDialog
          Record_ID={list.Record_ID}
          Type="List"
          Name={list.List_Name}
          handleDelete={handleDelete}
          handleMenuClose={handleClose}
        />
      </Menu>
    </React.Fragment>
  );
};

export default ProjectListActionMenu;
